<template>
    <div class="bg-neutral-900 py-12">
        <div class="mx-auto max-w-screen-xl">
            <div class="text-center">
                © {{appName}}
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    name: 'Foot',
    components: {},
    data() {
      return {
          appName: import.meta.env.VITE_APP_NAME,
      };
    },
    computed: {},
    props: {},
    watch: {},
});
</script>

<style scoped lang="scss">

</style>
